import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';
import { withBuyonlineAccessToken } from '../core/buy-insurance-access.util';

@Injectable()
export class SendEmailService {
  constructor(public httpClient: HttpClient, public wpTokenService: WpTokenService) {}

  private VERIFY_TOKEN_EXPIRE = false;

  httpClientOptions() {
    const httpClientOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      observe: 'response' as 'body'
    };
    if(this.VERIFY_TOKEN_EXPIRE){
      let token = this.wpTokenService.getToken();
      httpClientOptions.headers['Authorization'] = token;
    }
    return httpClientOptions;
  }

  input(param: Record<string, unknown>, referenceID?: string) {
    const reference = referenceID || (param.referenceID as string);
    const { email, ...rest } = param;
    return withBuyonlineAccessToken(reference, rest);
  }

  output(result: unknown) {
    return result;
  }

  connector(param: Record<string, unknown>, referenceID?: string) {
    const url = `${environment.endpointBackend}/api/notification/sendNotification`;
    const body = this.input(param, referenceID);
    return this.httpClient.post(url, body, this.httpClientOptions());
  }

  exec(param: Record<string, unknown>, referenceID?: string) {
    const self = this;
    const reference = referenceID || (param.referenceID as string);
    return new Promise(function(resolve, reject) {
      if(!self.VERIFY_TOKEN_EXPIRE || !self.wpTokenService.isTokenExpired()){
        self.connector(param, reference).subscribe(
          res => {
            self.wpTokenService.storeToken(res['headers'].get('Authorization'));
            resolve(self.output(res['body']));
          },
          err => {
            reject(err);
          }
        );
      } else {
        reject({
          name: 'WP_TOKEN_EXCEPTION',
          httpStatus:  401,
          message: 'token is expired'
        });
      }
    });
  }
}
